__turbopack_context__.v({
  "flex": "xLzFza_flex",
  "fullWidth": "xLzFza_fullWidth",
  "gap-large": "xLzFza_gap-large",
  "gap-medium": "xLzFza_gap-medium",
  "gap-minimal": "xLzFza_gap-minimal",
  "gap-small": "xLzFza_gap-small",
  "gap-tiny": "xLzFza_gap-tiny",
  "gapColumn-large": "xLzFza_gapColumn-large",
  "gapColumn-medium": "xLzFza_gapColumn-medium",
  "gapColumn-minimal": "xLzFza_gapColumn-minimal",
  "gapColumn-small": "xLzFza_gapColumn-small",
  "gapColumn-tiny": "xLzFza_gapColumn-tiny",
  "gapRow-large": "xLzFza_gapRow-large",
  "gapRow-medium": "xLzFza_gapRow-medium",
  "gapRow-minimal": "xLzFza_gapRow-minimal",
  "gapRow-small": "xLzFza_gapRow-small",
  "gapRow-tiny": "xLzFza_gapRow-tiny",
});
